export function getArray(data) {
    if (!data) return [];
    return data.split(",");
}
